import { documentDesignService } from '../../../services/documentDesignService';
import { buildStandaloneHtmlDocument } from './mediaCreatorHtmlDownload';

/** Server Chromium export only when explicitly enabled (not supported on Azure Flex). */
export function preferChromiumExport() {
  return process.env.REACT_APP_MC_EXPORT === 'chromium';
}

export async function captureCompositionViaChromium({
  compositionId,
  layout,
  assetUrls,
  title,
  scale = 2,
}) {
  const w = layout?.size_px?.width || 1920;
  const h = layout?.size_px?.height || 1080;
  const html = buildStandaloneHtmlDocument({ layout, assetUrls, title });
  return documentDesignService.exportCompositionRender(compositionId, {
    html,
    width: w,
    height: h,
    scale,
  });
}

export function downloadBlobAsFile(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = filename;
  link.href = url;
  link.click();
  URL.revokeObjectURL(url);
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Could not read export blob'));
    reader.readAsDataURL(blob);
  });
}
